import $ from "jquery";

const init = () => {
  if ($(".wpf_items_wrapper").length > 0) {
    addChevronIcon();
    initDropdown();
  }
};

const addChevronIcon = () => {
  $(".wpf_hierachy > [class^='wpf_product_cat'] > label").wrap(
    "<div class='toggle-container'></div>"
  );

  $(".wpf_submenu.wpf_level_2 > [class^='wpf_product_cat'] > label").wrap(
    "<div class='toggle-container'></div>"
  );

  $(".toggle-container").append(
    '<img class="toggle-btn" src="/wp-content/themes/hello-elementor-mi/assets/images/up.svg" alt="toggle-chevron" />'
  );
};

const initDropdown = () => {
  let dropdownMenuItemTitles = document.querySelectorAll(
    ".toggle-container img"
  );

  // let dropdownMenu = document.querySelectorAll(".toggle-container + ul ");

  dropdownMenuItemTitles.forEach((menuItemTitle) => {
    menuItemTitle.addEventListener("load", (e) => {
      const menuItemData =
        e.currentTarget.closest(".toggle-container").nextElementSibling;

      menuItemData.style.setProperty(
        "--openHeight",
        menuItemData.scrollHeight + "px"
      );

      menuItemData.classList.toggle("show");
      menuItemData.classList.toggle("hide");
      menuItemTitle.classList.toggle("down");
    });
  });

  dropdownMenuItemTitles.forEach((menuItemTitle) => {
    menuItemTitle.addEventListener("click", (e) => {
      const menuItemData =
        e.currentTarget.closest(".toggle-container").nextElementSibling;

      menuItemData.style.setProperty(
        "--openHeight",
        menuItemData.scrollHeight + "px"
      );

      menuItemData.classList.toggle("show");
      menuItemData.classList.toggle("hide");
      menuItemTitle.classList.toggle("down");
    });
  });
};

try {
  init();
} catch (error) {
  console.log(error);
}
